import {
    segmentItemConfig,
    segmentIconItemConfig,
    segmentGroupConfig,
    component,
    mergeConfig,
} from '@salutejs/plasma-new-hope/css';

import { config as configSegmentItem } from './SegmentItem.config';
import { config as configSegmentGroup } from './SegmentGroup.config';
import { config as iconItemConfig } from './SegmentIconItem.config';

/**
 * Провайдер контекста для группы сегментов и хук для доступа к контексту.
 */
export { SegmentProvider, useSegment } from '@salutejs/plasma-new-hope/css';

const mergedSegmentItemConfig = mergeConfig(segmentItemConfig, configSegmentItem);
const mergedSegmentIconItemConfig = mergeConfig(segmentIconItemConfig, iconItemConfig);
const mergedSegmentGroupConfig = mergeConfig(segmentGroupConfig, configSegmentGroup);

/**
 * Компонент группы сегментов.
 */
export const SegmentGroup = component(mergedSegmentGroupConfig);
/**
 * Компонент сегмента.
 */
export const SegmentItem = component(mergedSegmentItemConfig);
/**
 * Компонент сегмента с иконкой.
 */
export const SegmentIconItem = component(mergedSegmentIconItemConfig);
